import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';

import {SessionService} from '../../services/session/session.service';
import {TeamCompanyUsersService} from '../../services/teamcompanyusers/teamcompanyusers.service';

@Injectable({providedIn: 'root'})
export class ClientBenefitsAccessGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private teamCompanyUsersService: TeamCompanyUsersService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (this.sessionService.isSuperAdmin()) {
      return true;
    }
    const response = await this.teamCompanyUsersService.getManagers();
    const roles = response?.plain?.() || response || [];
    const roleNames = new Set(roles.map((role: any) => role?.role).filter(Boolean));
    const isPureClientAdministrator = roleNames.has('client')
      && [...roleNames].every(roleName => roleName === 'client');
    return route.data.allowClient === false && isPureClientAdministrator
      ? this.router.parseUrl('/')
      : true;
  }
}
